export default function DeployPhoneIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_4565_6394'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_4565_6394)'>
        <path
          d='M2.4375 15.8984V10.4248H3.69132V15.8984H2.4375ZM4.8486 13.3721V7.89844H6.10242V13.3721H4.8486ZM8.77076 19.8984C8.34851 19.8984 7.9911 19.7511 7.69854 19.4563C7.40612 19.1616 7.25991 18.8015 7.25991 18.3761V5.42075C7.25991 4.99535 7.40612 4.63528 7.69854 4.34054C7.9911 4.04581 8.34851 3.89844 8.77076 3.89844H15.1042C15.5265 3.89844 15.8839 4.04581 16.1765 4.34054C16.4689 4.63528 16.6151 4.99535 16.6151 5.42075V18.3761C16.6151 18.8015 16.4689 19.1616 16.1765 19.4563C15.8839 19.7511 15.5265 19.8984 15.1042 19.8984H8.77076ZM15.3615 17.5826H8.51352V18.3761C8.51352 18.441 8.54034 18.5003 8.59397 18.5542C8.64761 18.6083 8.70654 18.6353 8.77076 18.6353H15.1042C15.1685 18.6353 15.2274 18.6083 15.281 18.5542C15.3347 18.5003 15.3615 18.441 15.3615 18.3761V17.5826ZM8.51352 16.3195H15.3615V7.47738H8.51352V16.3195ZM8.51352 6.21423H15.3615V5.42075C15.3615 5.35591 15.3347 5.29654 15.281 5.24265C15.2274 5.18861 15.1685 5.1616 15.1042 5.1616H8.77076C8.70654 5.1616 8.64761 5.18861 8.59397 5.24265C8.54034 5.29654 8.51352 5.35591 8.51352 5.42075V6.21423ZM17.7726 15.8984V10.4248H19.0264V15.8984H17.7726ZM20.1837 13.3721V7.89844H21.4375V13.3721H20.1837Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
